import { map, catchError } from 'rxjs/operators';
import { DateService } from '@core/services';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { Observable, throwError } from 'rxjs';
import { QueryOptions, Message } from '@models/system';
import { type HttpService } from '@http/services';
import { Administrator } from '@models/domain';

@Injectable({
    providedIn: 'root'
})
export class AdministratorService implements HttpService<Administrator> {

    constructor(private http: HttpClient) {}

    fetch(qo: QueryOptions) : Observable<HttpResponse<Administrator[]>> {
        return this.http.get<Administrator[]>(env.API_URL + '/administrators', {
            params: qo.toObject(), // { offset: qo.offset, limit: qo.limit, eq: qo.eq, dig: qo.dig}, 
            observe: 'response'
        });
    }

    get(id: string) : Observable<HttpResponse<Administrator>> {
        return this.http.get<Administrator>(env.API_URL + '/administrators/' + id, {
            params: {},
            observe: 'response'
        }).pipe(
            map( resp => {
                if (resp.body != null && resp.body.administrator_id) {
                    resp.body.access_start = DateService.toDateString(resp.body.access_start);
                    resp.body.access_end = DateService.toDateString(resp.body.access_end);
                }
                return resp;
            })
        );
    }

    post(t: Administrator): Observable<HttpResponse<Administrator>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        t = this.sanitize(t);
        return this.http.post<Administrator>(env.API_URL + '/administrators', t, {
            params: {},
            observe: 'response'
        });
    }

    put(t: Administrator): Observable<HttpResponse<Message>> { 
        //return throwError(() => new Error("Invalid API service call attempt"));
        t = this.sanitize(t);
        return this.http.put<Message>(env.API_URL + '/administrators/' + t.administrator_id, t, {
            params: {},
            observe: 'response'
        });
    }

    delete(id: string) : Observable<HttpResponse<Message>> {
        //return throwError(() => new Error("Invalid API service call attempt"));
        return this.http.delete<Message>(env.API_URL + '/administrators/' + id, {
            params: {},
            observe: 'response'
        });
    }

    sanitize(t: Administrator): Administrator {

        //date
        t.access_end = DateService.to8601String(t.access_end);
        t.access_start = DateService.to8601String(t.access_start);
        //number
        //t.ip_limit = parseInt(t.ip_limit + "");
        //t.download_limit = parseInt(t.download_limit + "");
        //nullable
        //t.middlename = t.middlename == "" ? null : t.middlename;

        return t
    }

}
